export const checkIsSafari = () => /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
